export default "__VITE_ASSET__DJr6$CaV__"